import { Pipe, PipeTransform } from '@angular/core';
import { JobSource } from '@apply4u/features/jobs/enums/job-source.enum';
import { IsNotNull, IsNotNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { EncodeToBase64 } from '@apply4u/shared/helpers/encoding-helper';
import { FormatSeoUrl } from '@apply4u/shared/helpers/seo-helper';

@Pipe({
  name: 'JobApplyNowUrlPipe',
  standalone:true
})
export class JobApplyNowUrlPipe implements PipeTransform {
  constructor() { 
  }

  transform(title: string, location: string, id: number, jobSourceId: number = null,applicationUrl: string = null): string {
    let applyUrl = `/jobs/applynow/${id}/${this.GetFormattedJobTitleForApplyNowURL(title, location)}`;
    
    if (IsNotNull(jobSourceId) && IsNotNullOrEmpty(applicationUrl) && jobSourceId == JobSource.Barchester) {
      applyUrl = `/jobs/applynow/${id}/${jobSourceId}/${EncodeToBase64(applicationUrl)}`;
    }

    return applyUrl;
  }

  GetFormattedJobTitleForApplyNowURL(jobTitle: string, location: string): string {
    let formattedString = "";

    if (jobTitle != null && jobTitle != "") {
      formattedString = jobTitle;

      if (location !== undefined && location != null && location != "") {
        formattedString = formattedString + "-jobs"
        formattedString = formattedString + "-in-" + location;
      } else {
        formattedString = formattedString.trim() + "-jobs"
      }

      formattedString = FormatSeoUrl(formattedString);
      formattedString = formattedString.toLowerCase();
    } else {
      formattedString = "job"
    }

    formattedString = formattedString.trim();

    return formattedString;
  }
}